const Footer = () => {
  return (
    <footer className="w-full py-2 px-4">
      <p className="text-xs font-bold text-[#621C43] text-end">Powered by Bluenumber®</p>
    </footer>
  );
};

export default Footer;
